const baseUrl = process.env.REACT_APP_PLATFORM_ADMIN_API_URL || "https://api.facturize.net/api/fe/v1/platform-admin";

export const platformAdminToken = () => sessionStorage.getItem("platformAdminToken") || "";

export const platformAdminHeaders = () => ({
  "X-Platform-Admin-Token": platformAdminToken(),
});

export const loginPlatformAdmin = async (email, senha) => {
  const response = await fetch(`${baseUrl}/auth/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, senha }),
  });
  const data = await response.json();
  if (!response.ok || !data?.data?.token) throw new Error(data?.error || "Credenciais administrativas inválidas.");
  sessionStorage.setItem("platformAdminToken", data.data.token);
  return data.data.user;
};

export const clearPlatformAdmin = () => sessionStorage.removeItem("platformAdminToken");

